import React, { Fragment as F } from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'

import Icon from 'discada/dist/Icon'
import { Accordion } from 'discada/dist/Expando'

import {
  hasDataOneData,
  getChromeEquipment,
  getDataOneEquipment,
} from 'selectors/inventorySelectors'

import './Equipment.scss'

//////////////////////////
//
export function ChromeEquipmentSection({ name, items }) {
  let installedItems = items.filter(item => item.installReason)

  if (!installedItems.length) return null

  return (
    <div className={c('equipment-section', `equipment-section-${name}`)}>
      <ul>
        {installedItems.map((item, i) => (
          <li key={i}>
            <Icon icon="circle" />
            <span>{item.value}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}

export function DataOneEquipmentSection({ name, items }) {
  return (
    <div
      className={c(
        'equipment-section',
        'data-one-equipment',
        `equipment-section-${name}`,
      )}
    >
      {Object.keys(items).map(k => (
        <F key={k}>
          <strong>{k}</strong>
          <ul>
            {Object.keys(items[k]).map(kk => (
              <li key={kk}>
                {items[k][kk].length ? `${kk}: ${items[k][kk].join(', ')}` : kk}
              </li>
            ))}
          </ul>
        </F>
      ))}
    </div>
  )
}

//////////////////////////

export function VehicleEquipment(props) {
  let { equipment, useDataOne } = props,
    Section = useDataOne ? DataOneEquipmentSection : ChromeEquipmentSection

  if (isEmpty(equipment)) return null

  return (
    <div
      className={c('vehicle-equipment', { 'data-one-equipment': useDataOne })}
      id="vrp-equipment"
    >
      <Accordion items={Object.keys(equipment)} header={({ item }) => item}>
        {({ item }) => (
          <Section name={item} key={item} items={equipment[item]} />
        )}
      </Accordion>
    </div>
  )
}

function mapStateToProps(state, op) {
  let useDataOne = hasDataOneData(state, op.id)

  return {
    ...op,
    useDataOne,
    equipment: useDataOne
      ? getDataOneEquipment(state, op.id)
      : getChromeEquipment(state, op.id),
  }
}

export default connect(mapStateToProps)(VehicleEquipment)
